import { useEffect } from 'react'
import { UAParser } from 'ua-parser-js'

export default function BridgeReceiver() {
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    let parserObj = new UAParser()
    const agentInfo = parserObj.getResult()
    const deviceInfo = parserObj.getDevice()
    const OSInfo = parserObj.getOS()
    const msgResposne = (message) => {
      // console.log('BridgeReceiver log')
      // console.log(message)
    }
    if (OSInfo['name'] === 'Android') {
      document.addEventListener('message', msgResposne)
    } else {
      window.addEventListener('message', msgResposne)
    }

    return () => {
      if (OSInfo['name'] === 'Android') {
        document.removeEventListener('message', msgResposne)
      } else {
        window.removeEventListener('message', msgResposne)
      }
    }
  }, [])

  return null
}
